import { defineStore } from "pinia"

export const useTeacherTimerStore = defineStore("teacherTimerStore", {
  state: () => ({
    open: false,
    minimized: false,
    status: "idle" as "idle" | "running" | "paused",
    durationSeconds: 0,
    remainingSeconds: 0,
    endAt: 0,
    intervalId: null as ReturnType<typeof setInterval> | null,
    finishCount: 0,
    soundEnabled: true,
  }),

  getters: {
    isCountingDown: (state) => state.status === "running" || state.status === "paused",

    progressPercent(state): number {
      if (state.durationSeconds === 0) {
        return 0
      }
      return (state.remainingSeconds / state.durationSeconds) * 100
    },

    isDanger(state): boolean {
      return this.isCountingDown && state.remainingSeconds <= 10
    },
  },

  actions: {
    openTimer() {
      this.open = true
      this.minimized = false
      useGAEvent("teacher_tool_used", { tool: "timer" })
    },

    closeTimer() {
      this.clearTick()
      this.open = false
      this.minimized = false
      this.status = "idle"
      this.remainingSeconds = this.durationSeconds
    },

    yieldToOtherTool() {
      if (!this.open) {
        return
      }
      if (this.isCountingDown) {
        this.minimized = true
      } else {
        this.closeTimer()
      }
    },

    toggleSound() {
      this.soundEnabled = !this.soundEnabled
    },

    setDuration(seconds: number) {
      this.durationSeconds = seconds
      if (this.status === "idle") {
        this.remainingSeconds = seconds
      }
    },

    start() {
      if (this.status === "running" || this.durationSeconds === 0) {
        return
      }
      if (this.status === "idle" || this.remainingSeconds === 0) {
        this.remainingSeconds = this.durationSeconds
      }
      this.endAt = Date.now() + this.remainingSeconds * 1000
      this.status = "running"
      this.clearTick()
      this.intervalId = setInterval(() => this.tick(), 250)
    },

    pause() {
      if (this.status !== "running") {
        return
      }
      this.clearTick()
      this.remainingSeconds = Math.max(0, Math.ceil((this.endAt - Date.now()) / 1000))
      this.status = "paused"
    },

    reset() {
      this.remainingSeconds = this.durationSeconds
      if (this.status === "running") {
        this.endAt = Date.now() + this.durationSeconds * 1000
      }
    },

    stopToIdle() {
      this.clearTick()
      this.status = "idle"
      this.remainingSeconds = this.durationSeconds
    },

    tick() {
      this.remainingSeconds = Math.max(0, Math.ceil((this.endAt - Date.now()) / 1000))
      if (this.remainingSeconds === 0) {
        this.finish()
      }
    },

    finish() {
      this.clearTick()
      this.status = "idle"
      this.remainingSeconds = 0
      this.finishCount++
    },

    clearTick() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
  },
})
